<app-stepper
  [step]="2"
></app-stepper>
<h2 class="mt-5 fw-bold">
  {{ project.name }}
</h2>
<div class="lead">
  Lorem ipsum dolor sit amet, consetetur sadipscing elitr.
</div>

<form [formGroup]="demoForm">
  <div class="mt-4">
    <div class="row">
      <div class="col-12 mb-3">
        <app-form-input-text
          [formName]="demoForm"
          [control]="firstnameControl"
          [name]="'firstname'"
          [label]="'Vorname'"
          [placeholder]="'Vorname'"
          [required]="true"
          [cssClasses]="''"
          [type]="'text'"
        >
        </app-form-input-text>
      </div>
      <div class="col-12 mb-3">
        <app-form-input-text
          [formName]="demoForm"
          [control]="tooltipFieldControl"
          [name]="'tooltipField'"
          [label]="'Tolles Feld mit Tooltip'"
          [placeholder]="'Tolles Feld mit Tooltip'"
          [required]="true"
          [cssClasses]="''"
          [type]="'text'"
          [toolTipMessage]="'krasser tooltip ist das hier! richtig tolle information!'"
        >
        </app-form-input-text>
      </div>
      <div class="col-12 mb-4">
        <app-form-input-text
          [formName]="demoForm"
          [control]="testValidControl"
          [name]="'testValid'"
          [label]="'Testinput valid prestyled'"
          [required]="true"
          [cssClasses]="'is-valid'"
          [type]="'text'"
        >
        </app-form-input-text>
      </div>
      <div class="col-6 mb-4">
        <app-form-input-text
          [formName]="demoForm"
          [control]="testInvalidControl"
          [name]="'testInvalid'"
          [label]="'Testinput invalid prestyled'"
          [required]="true"
          [cssClasses]="'is-invalid'"
          [type]="'text'"
        >
        </app-form-input-text>
      </div>
      <div class="col-6 mb-4">
        <app-form-input-date></app-form-input-date>
      </div>
    </div>
  </div>
  <hr>
  <div class="mt-4">
    <div class="row">
      <div class="col-12 mb-4">
        <app-form-input-dropdown
          [formName]="demoForm"
          [control]="salutationControl"
          [values]="salutationValues"
          [cssClasses]="''"
          [placeholder]="'Bitte wählen Sie'"
          [label]="'Anrede ohne Vorauswahl'"
        >
        </app-form-input-dropdown>
      </div>
      <div class="col-6 mb-4">
        <app-form-input-dropdown
          [formName]="demoForm"
          [control]="salutationControl"
          [values]="salutationValues"
          [cssClasses]="'is-valid'"
          [selectedValue]="'Herr'"
          [placeholder]="'Bitte wählen Sie'"
          [label]="'Anrede mit Vorauswahl valide'"
        >
        </app-form-input-dropdown>
      </div>
      <div class="col-6 mb-4">
        <app-form-input-dropdown
          [formName]="demoForm"
          [control]="salutationControl"
          [values]="salutationValues"
          [cssClasses]="'is-invalid'"
          [selectedValue]="'Herr'"
          [placeholder]="'Bitte wählen Sie'"
          [label]="'Anrede mit Vorauswahl invalide'"
        >
        </app-form-input-dropdown>
      </div>
      <div class="col-12 mb-4">
        <app-form-input-dropdown
          [formName]="demoForm"
          [control]="salutationControl"
          [values]="salutationValues"
          [cssClasses]="''"
          [placeholder]="'Bitte wählen Sie'"
          [label]="'Anrede mit Tooltip'"
          [toolTipMessage]="'krasser tooltip ist das hier! richtig tolle information!'"
        >
        </app-form-input-dropdown>
      </div>
    </div>
  </div>
  <hr/>
  <div class="my-5">
    <app-form-input-checkbox
      [formName]="demoForm"
      [control]="tosControl"
      [name]="'tos'"
      [label]="'Ich stimme ausdrücklich zu, dass meine\n'+
'  persönlichen Daten, also Name, Adresse, Telefonnummer, Email, Geburtsdatum sowie alle weiteren,\n'+
'  zum Nachweis der Ansprüche erforderlichen und/oder nützlichen sonstige Daten zum Zweck der Rechtsverfolgung meiner\n'+
'  Ansprüche verarbeitet werden. Diese Einwilligung kann ich jederzeit widerrufen.'"
      [required]="true"
      (onValueChanged)="$event"
    >
    </app-form-input-checkbox>
  </div>
</form>
<hr/>

<!-- TODO: @Roland move to component this is the contract box -->

<div class="rounded-lg bg-light py-5 ps-5 pe-4">
  <div class="contract-box overflow-y-auto lh-lg">
    <div class="pe-4">
      <h3>1. Leistungen von Advofin</h3>
      <p>AdvoFin trägt nach Maßgabe folgender Bestimmungen die Kosten der Rechtsverfolgung für die Geltendmachung meiner
        Ansprüche wegen erlittener Spielverluste bei Online-Glückspielen, (i) bei denen die Spielteilnahme in Österreich
        über elektronische Medien erfolgt ist, und (ii) für welche der Anbieter keine Konzession nach dem
        österreichischen
        Glücksspielgesetz besitzt, insbesondere Ansprüche auf Rückzahlung und/oder Schadenersatz („Streitige
        Ansprüche“).
        Anspruchsgegner ist der jeweilige Anbieter des Online-Glücksspiels und/oder der bei der betroffenen
        Spielteilnahme
        tätige Zahlungsdienstleister.
      </p>
      <p>
        AdvoFin wird zunächst die Verfolgung der Streitigen Ansprüche des Kunden im außergerichtlichen Wege durch den
        beauftragten Rechtsanwalt/die beauftragte Rechtsanwaltsgesellschaft finanzieren.
      </p>
      <p>
        AdvoFin ist verpflichtet, die Kosten zu übernehmen, die im Rahmen einer sparsamen und wirtschaftlichen
        außergerichtlichen und/oder AdvoFin trägt nach Maßgabe folgender Bestimmungen die Kosten der Rechtsverfolgung
        für die Geltendmachung meiner Ansprüche wegen erlittener Spielverluste bei Online-Glückspielen, (i) bei denen
        die Spielteilnahme in Österreich über elektronische Medien erfolgt ist, und (ii) für welche der Anbieter keine
        Konzession nach dem österreichischen Glücksspielgesetz besitzt, insbesondere Ansprüche auf Rückzahlung und/oder
        Schadenersatz („Streitige Ansprüche“). Anspruchsgegner ist der jeweilige Anbieter des Online-Glücksspiels
        und/oder der bei der betroffenen Spielteilnahme tätige Zahlungsdienstleister.
      </p>
    </div>
  </div>
</div>

<div class="row mt-5">
  <div class="col">
    <app-form-button-submit
      [active]="false"
      [label]="'Abschicken'"
      [value]="'Abschicken'"
    ></app-form-button-submit>
  </div>
  <div class="col">
    <app-form-button-submit
      [active]="true"
      [label]="'Abschicken'"
      [value]="'Abschicken'"
    ></app-form-button-submit>
  </div>
</div>

<div>
  <app-modal></app-modal>
</div>
